import { Badge, StateBadge } from '../../../ui/Badge';
import { Button } from '../../../ui/Button';
import { Card, KeyValue } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { AttemptDetail } from '../types';

export function DeployRunCard({
  a,
  setCheckDialog,
}: {
  a: AttemptDetail;
  setCheckDialog: (name: string | null) => void;
}) {
  if (!a.run) return null;
  const b = a.binding;
  return (
    <Card
      title="Deploy run"
      subtitle={
        <>
          Reported by GitHub <Timestamp value={a.run.receivedAt} />
        </>
      }
    >
      <KeyValue
        items={[
          ['Conclusion', <StateBadge key="c" state={a.run.conclusion} />],
          [
            'Run',
            <a key="u" href={a.run.url} target="_blank" rel="noopener noreferrer nofollow">
              {a.run.url}
            </a>,
          ],
          ['Started', <Timestamp key="s" value={a.run.startedAt} />],
          ['Finished', <Timestamp key="f" value={a.run.finishedAt} />],
        ]}
      />
      {a.awaitingVerification && (
        <>
          <span className="small strong">Verification checks</span>
          <ul className="checklist">
            {b.verificationChecks.map((c) => {
              const r = a.checks.find((x) => x.name === c);
              const manual = a.manualChecks.includes(c);
              return (
                <li key={c}>
                  {r ? (
                    <Badge tone={r.passed ? 'success' : 'error'}>{r.passed ? 'Passed' : 'Failed'}</Badge>
                  ) : (
                    <Badge tone="warning">No result</Badge>
                  )}{' '}
                  {c} <span className="small muted">({manual ? 'manual' : 'automatic'})</span>
                  {r?.observation && <span className="small muted"> — {r.observation}</span>}
                  {manual && a.viewer.canRecordChecks && (
                    <>
                      {' '}
                      <Button size="sm" variant="ghost" onClick={() => setCheckDialog(c)}>
                        {r ? 'Change result' : 'Record result'}
                      </Button>
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </Card>
  );
}
